import BlankPage from "./BlankPage";

const BlankPageContainer = () => {

  return (
    <BlankPage />
  );
};

export default BlankPageContainer;
